(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Custom-Announcement"] && !Shopify.designMode) return;
  try {
    
  //   $(document).ready(function() {
  //   function updateCountdown() {
  //     var $countdownBoxes = $(".countdown-wrapper-box");
  //     var allCountdownsCompleted = true;

  //     $countdownBoxes.each(function() {
  //       var $this = $(this);
  //       var endDateStr = $this.data("end-date");
  //       var endDate = new Date(endDateStr.replace(/-/g, "/"));
  //       var now = new Date();
  //       var timeDiff = endDate - now;
  //       console.log('time different: ',timeDiff);

  //       if (timeDiff <= 0) {
  //         allCountdownsCompleted = true;
  //       } else {
  //         allCountdownsCompleted = false;

  //         var days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  //         var hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  //         var minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
  //         var seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

  //         $this.find(".js-timer-days").text(days < 10 ? '0' + days : days);
  //         $this.find(".js-timer-hours").text(hours < 10 ? '0' + hours : hours);
  //         $this.find(".js-timer-minutes").text(minutes < 10 ? '0' + minutes : minutes);
  //         $this.find(".js-timer-seconds").text(seconds < 10 ? '0' + seconds : seconds);
  //       }
  //     });

  //     console.log(allCountdownsCompleted);
  //     if (allCountdownsCompleted) {
  //       $(".middle-slide").show();
  //       $(".countdown-main-wrapper").hide();
  //     } else {
  //       $(".middle-slide").hide();
  //       $(".countdown-main-wrapper").show();
  //     }
  //   }
  //   setInterval(updateCountdown, 1000);
  //   updateCountdown();
  // });

  $(document).ready(function () {
    function updateCountdown() {
      var $countdownBoxes = $('.countdown-wrapper-box');
      var allCountdownsCompleted = true;

      $countdownBoxes.each(function () {
        var $this = $(this);
        var endDateStr = $this.data('end-date');
        var endDate = new Date(endDateStr.replace(/-/g, '/'));
        var now = new Date();
        var timeDiff = endDate - now;

        if (timeDiff <= 0) {
          // This countdown is completed - no action needed
        } else {
          // At least one countdown is still active
          allCountdownsCompleted = false;

          // Calculate and display remaining time
          var days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
          var hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

          $this.find('.js-timer-days').text(days < 10 ? '0' + days : days);
          $this.find('.js-timer-hours').text(hours < 10 ? '0' + hours : hours);
          $this.find('.js-timer-minutes').text(minutes < 10 ? '0' + minutes : minutes);
          $this.find('.js-timer-seconds').text(seconds < 10 ? '0' + seconds : seconds);
        }
      });

      // After checking all countdowns, update visibility
      if (allCountdownsCompleted) {
        $('.middle-slide').show();
        $('.countdown-main-wrapper').hide();
      } else {
        $('.middle-slide').hide();
        $('.countdown-main-wrapper').show();
      }
    }

    setInterval(updateCountdown, 1000);
    updateCountdown();
  });

  } catch(e) { console.error(e); }
})();
})();
